function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 70,
  r: 70,
  fill: "#0085FF",
  fillOpacity: 0.08
});
var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#empty-search_svg__filter0_d_426_30)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 23,
  y: 62,
  width: 130,
  height: 21,
  rx: 2,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fill: "#A0AFBE",
  d: "M26 65h124v6H26zM26 74h49v6H26z"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#empty-search_svg__filter1_d_426_30)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 23,
  y: 40,
  width: 130,
  height: 12,
  rx: 2,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fill: "#A0AFBE",
  d: "M26 43h106v6H26z"
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#empty-search_svg__filter2_d_426_30)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 23,
  y: 93,
  width: 130,
  height: 12,
  rx: 2,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fill: "#A0AFBE",
  d: "M26 96h88v6H26z"
}));
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M115.714 105.429c11.44 0 20.715-9.275 20.715-20.715S127.154 64 115.714 64 95 73.274 95 84.714s9.274 20.715 20.714 20.715z",
  fill: "#0085FF",
  fillOpacity: 0.05,
  stroke: "#A0AFBE",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M132.285 101.286L153 122",
  stroke: "#A0AFBE",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "empty-search_svg__filter0_d_426_30",
  x: 15,
  y: 56,
  width: 146,
  height: 37,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_426_30"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_426_30",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "empty-search_svg__filter1_d_426_30",
  x: 15,
  y: 34,
  width: 146,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_426_30"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_426_30",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "empty-search_svg__filter2_d_426_30",
  x: 15,
  y: 87,
  width: 146,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_426_30"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_426_30",
  result: "shape"
})));
function SvgEmptySearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 140,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}
export default SvgEmptySearch;